/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { FILTER_OPTION } from '@api/articles/constants';
import { useArticlesPublishedList } from '@api/hooks';
import { useArticleFilterOptions } from '@hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';
import TableSelect from '../TableSelect';

const ArticleSelect = ({ placeholder = 'Type the name of article...', isTypeFilter = false, ...props }) => {
  const filterOptions = useArticleFilterOptions();
  const [articleType, setArticleType] = React.useState(FILTER_OPTION.ALL.key);

  return (
    <>
      {isTypeFilter && (
        <TableSelect
          style={{ marginBottom: 10 }}
          defaultValue={articleType}
          onSelect={setArticleType}
          options={filterOptions}
        />
      )}
      <SearchableEntitySelect
        placeholder={placeholder}
        useList={useArticlesPublishedList}
        formatLabel={({ title }) => title}
        {...props}
        queryVariables={{ ...props.queryVariables, type: articleType }}
      />
    </>
  );
};

export default ArticleSelect;
